import React from 'react'
import logo from './../../assets/logo.svg';
import { CiMail } from 'react-icons/ci';
import { BsFacebook, BsLinkedin, BsTwitter } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ScrollToTopBTN from '../ScrollToTopBTN/ScrollToTopBTN.jsx';
import { PiPhoneThin } from 'react-icons/pi';

const Footer = () => {
    return (
        <footer>
            <ScrollToTopBTN />
            <div className="top bg-cyan">
                <div className="w-5/6 lg:w-4/6 m-auto grid grid-cols-5">
                    <div className="col-span-3 md:col-span-2 logo bg-main p-6 px-10">
                        <img src={logo} alt="" />
                    </div>
                </div>
            </div>
            <div className="foot bg-main text-white ">
                <div className="w-5/6 lg:w-4/6 m-auto py-10 grid grid-cols-5 gap-10 lg:gap-20">
                    <motion.div
                        initial={{
                            y: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            y: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="col-span-5 md:col-span-2 flex flex-col gap-5">
                        <p className="text-sm font-Krub leading-[24.24px] text-gray-light">Leverage agile frameworks to provide a robust synopsis for strategy  collaborative thinking to further the overall value proposition.</p>
                        <div className="email flex items-center  gap-4">
                            <div className="text-main bg-white rounded-full p-4">
                                <CiMail size={20} />
                            </div>
                            <div className="font-Krub text-sm">
                                <p>Email</p>
                                <span>secureTech@gmail.com</span>
                            </div>
                        </div>
                        <div className="phone flex items-center gap-4">
                            <div className="text-main bg-white rounded-full p-4">
                                <PiPhoneThin size={20} />
                            </div>
                            <div className="font-Krub text-xs">
                                <p>Call Us</p>
                                <span>(971) 964 485 5484</span>
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{
                            x: -300,
                            opacity: 0,
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="col-span-5 md:col-span-3 grid grid-cols-3 gap-10">
                        <div className="routes col-span-3 sm:col-span-1 flex sm:flex-col gap-4 text-sm font-Krub">
                            <Link className="hover:text-gold" to="/about">About Us</Link>
                            <Link className="hover:text-gold" to="/projects">Our Project</Link>
                            <Link className="hover:text-gold" to="/contact">Contact</Link>
                        </div>
                        <div className="send-mail col-span-3 sm:col-span-2">
                            <input type="text" className='py-5 px-5 w-full' placeholder="Email here*" />
                            <div className="flex mt-4">
                                <button className='bg-cyan w-fit text-sm font-krub text-black font-semibold py-3 px-6 md:py-5 md:px-11'>Send Now</button>
                                <div className="social_links flex items-center px-4 gap-4">
                                    <a target="_blank" href="/" className="hover:text-gold">
                                        <BsFacebook />
                                    </a>
                                    <a target="_blank" href="/" className="hover:text-gold">
                                        <BsTwitter />
                                    </a>
                                    <a target="_blank" href="/" className="hover:text-gold">
                                        <BsLinkedin />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
                <div className="border-t">
                    <p className="font-Krub text-sm leading-10 w-5/6 lg:w-4/6 m-auto py-5">
                        Copyright © 2023 SecureTech.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer